import _ from 'underscore';
import { FORM_STATES } from '@bingads-webui-react/form';
import { getNeedConfirming } from '@bingads-webui-campaign-react/campaign-settings-utils';

import { SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS, SEARCH_CAMPAIGN_EDIT_WIZARD_STEP_PATHS, SEARCH_AD_GROUP_EDIT_WIZARD_STEP_PATHS, SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS } from './step-utils';
import { CampaignSettingsStep, useCampaignSettingsRepository } from './campaign-settings';
import { KeywordsStep, useKeywordsRepository } from './keywords';
import { AddTextStep, useAdsRepository } from './add-text';
import { ExtensionsStep, useExtensionsRepository } from './extensions';
import { BudgetAndBidsStep, useBudgetAndBidSettingsRepository } from './budget';
import { SummaryStep, useSummaryRepository } from './summary';
import { CampaignEditSettingsStep, useCampaignEditSettingsRepository } from './campaign-edit-settings';
import { AdGroupEditSettingsStep, useAdGroupEditSettingsRepository } from './adgroup-edit-settings';
import { AdGroupSettingsStep, useAdGroupSettingsRepository } from './adgroup-settings';
import { BidAndTargetStep, useBidAndTargetRepository } from './bid-and-target';
import { StandardAdTypes, DynamicAdTypes } from '../constants/ad-type';

export const searchCampaignCreationStepConfigs = permissions => [
  {
    id: SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.CAMPAIGN_SETTINGS,
    view: CampaignSettingsStep,
    repository: useCampaignSettingsRepository,
    machineOptions: {
      initialState: FORM_STATES.FETCHING,
    },
  },
  {
    id: SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.KEYWORDS,
    view: KeywordsStep,
    repository: useKeywordsRepository,
  },
  {
    id: SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.CREATE_AD,
    view: AddTextStep,
    viewProps: {
      enableAdsManagment: false,
      confirmWhenSwitchAdType: true,
      adTypes: StandardAdTypes,
    },
    repository: useAdsRepository,
    repositoryProps: {
      enableAdsManagment: false,
      adTypes: StandardAdTypes,
    },
  },
  {
    id: SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.ADD_MORE_ASSETS,
    view: ExtensionsStep,
    repository: useExtensionsRepository,
    repositoryProps: { permissions },
  },
  {
    id: SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.BUDGET_AND_BIDS,
    view: BudgetAndBidsStep,
    repository: useBudgetAndBidSettingsRepository,
  },
  {
    id: SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.SUMMARY,
    repository: useSummaryRepository,
    view: SummaryStep,
  },
];

const searchCampaignEditStepConfigs = [
  {
    id: SEARCH_CAMPAIGN_EDIT_WIZARD_STEP_PATHS.CAMPAIGN_EDIT_SETTINGS,
    view: CampaignEditSettingsStep,
    repository: useCampaignEditSettingsRepository,
    machineOptions: {
      initialState: FORM_STATES.FETCHING,
    },
  },
];

export const getSearchCampaignEditStepConfigs = permissions => searchCampaignEditStepConfigs.map((step) => {
  if (_.get(permissions, ['dynamic', 'ConversionAssociationWarningP2']) && step.id === SEARCH_CAMPAIGN_EDIT_WIZARD_STEP_PATHS.CAMPAIGN_EDIT_SETTINGS) {
    const mapStep = {
      ...step,
      machineOptions: {
        ...step.machineOptions,
        guards: {
          needsConfirming: context => getNeedConfirming(permissions, context),
        },
      },
    };
    return mapStep;
  }
  return step;
});

export const searchAdGroupCreationStepConfigs = [
  {
    id: SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.AD_GROUP_SETTINGS,
    view: AdGroupSettingsStep,
    repository: useAdGroupSettingsRepository,
    machineOptions: {
      initialState: FORM_STATES.FETCHING,
    },
  },
  {
    id: SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.KEYWORDS,
    view: KeywordsStep,
    repository: useKeywordsRepository,
  },
  {
    id: SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.CREATE_AD,
    view: AddTextStep,
    viewProps: {
      enableAdsManagment: true,
      adTypes: StandardAdTypes,
      description: _TL_('Create up to five Multimedia ads and three Responsive Search ads per ad group.'),
    },
    repository: useAdsRepository,
    repositoryProps: {
      enableAdsManagment: true,
      adTypes: StandardAdTypes,
    },
  },
  {
    id: SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.CREATE_DSA_AD,
    view: AddTextStep,
    viewProps: {
      enableAdsManagment: true,
      adTypes: DynamicAdTypes,
      description: _TL_('Create a maximum of 100 Dynamic Search ads per ad group.'),
    },
    repository: useAdsRepository,
    repositoryProps: {
      enableAdsManagment: true,
      adTypes: DynamicAdTypes,
    },
  },
  {
    id: SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.BID_AND_TARGET,
    view: BidAndTargetStep,
    repository: useBidAndTargetRepository,
  },
  {
    id: SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.BID_AND_TARGET_DSA,
    view: BidAndTargetStep,
    repository: useBidAndTargetRepository,
  },
];

export const searchAdGroupEditStepConfigs = [
  {
    id: SEARCH_AD_GROUP_EDIT_WIZARD_STEP_PATHS.AD_GROUP_EDIT_SETTINGS,
    view: AdGroupEditSettingsStep,
    repository: useAdGroupEditSettingsRepository,
    machineOptions: {
      initialState: FORM_STATES.FETCHING,
    },
  },
];
